import { Task } from "@/types/v2";
import { firestore } from "@/services/firestore";
import { generic } from "@/repositories/generic";

export const taskRepository = {
  subscribeAll: (
    shopId: string,
    viewerAuthUid: string,
    callback: (docs: Task[] | undefined) => void
  ) =>
    // Rules aren't filters: an unconstrained query against a per-document
    // read rule fails wholesale (permission-denied) the moment one private
    // task exists in the shop. This OR is shaped to match the tasks read
    // rule that WEBV3-304's Task 7 will add to firestore.rules — public
    // tasks, tasks the viewer created, tasks the viewer is assigned.
    //
    // No `orderByField` is passed here, but subscribeCollectionWQueries
    // unconditionally orders server-side by `id` regardless (see
    // firestore.ts's `query(colRef, orderBy("id"))` base query) — not
    // `dueDate`, which stays client-side (prepareTasks re-sorts by dueDate
    // on every snapshot, since it's optional on Task and Firestore would
    // exclude any doc missing it). The server-side `id` ordering silently
    // relies on every task document carrying a real `id` field — true today
    // (both generic.create and TaskRepository.create stamp one
    // unconditionally on every task write), but not enforced by the Task
    // type (`id` is optional there) or by any rule, so a future direct-write
    // path that omits `id` would have its doc silently excluded from every
    // subscribeAll result, not just unsorted.
    firestore.subscribeCollectionWQueries<Task>(
      `shops/${shopId}/tasks`,
      callback,
      [
        { searchParam: "isPrivate", opsString: "==", equality: false },
        { searchParam: "createdBy", opsString: "==", equality: viewerAuthUid },
        {
          searchParam: "assigneeAuthUid",
          opsString: "==",
          equality: viewerAuthUid,
        },
      ],
      undefined,
      1000,
      undefined,
      "asc",
      undefined,
      "or"
    ),
  create: (shopId: string, data: Partial<Task>) =>
    generic.create<Task & { id: string }>(data, `shops/${shopId}/tasks/`),
  update: (shopId: string, id: string, data: Partial<Task>) =>
    generic.update<Task>(data, `shops/${shopId}/tasks/${id}`),
  delete: (shopId: string, id: string, hardDelete?: boolean) =>
    generic.delete(id, `shops/${shopId}/tasks`, hardDelete),
};
